import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import * as XLSX from 'xlsx';

import './BuildingParkingDayConfig.scss';

import { setBuildingParkingDayConfig } from '../../actions';
import commonConstant from '../../common/_commonConstant';

import {  
  HeaderSection,  
  Card,
  Dropdown,
  InputWithUpload,
  dateUTCYYYYMMDD,
  timeUTCFormatHHMM,
} from '../../helpers';

class BuildingParkingDayConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {      
      'weekdayAllowance' : [],
      'weekdayChargeCustomer' : [],      
      'weekendAllowance' : [],
      'weekdayParkingDayConfigId': [],
      'weekendChargeCustomer' : [],      
      'weekendParkingDayConfigId': [],
      'customDayConfigData': [],
      'file': null,
      'error': false,
      'alreadyUploaded' : false,
    };
    
    this.weekdayAllowance = [];
    this.weekdayChargeCustomer = [];    
    this.weekendAllowance = [];
    this.weekendChargeCustomer = [];
  }

  componentDidMount() {
    const { buildingParkingDayConfig } = this.props;
    if (buildingParkingDayConfig != null) {
      const weekdayParkingDayConfig = buildingParkingDayConfig.parkingDayConfig.filter((data) => data.parkingDayConfigDayType === 'WEEKDAY');
      weekdayParkingDayConfig.sort((a, b) => parseInt(a.parkingDayConfigParkingZone.split('-')[2], 10) - parseInt(b.parkingDayConfigParkingZone.split('-')[2], 10));
      const weekendParkingDayConfig = buildingParkingDayConfig.parkingDayConfig.filter((data) => data.parkingDayConfigDayType === 'WEEKEND');
      weekendParkingDayConfig.sort((a, b) => parseInt(a.parkingDayConfigParkingZone.split('-')[2], 10) - parseInt(b.parkingDayConfigParkingZone.split('-')[2], 10));
      this.handleSetInitialData(weekdayParkingDayConfig, 'weekday');
      this.handleSetInitialData(weekendParkingDayConfig, 'weekend');
      if (buildingParkingDayConfig.parkingDayConfig.filter((data) => data.parkingDayConfigDayType === 'CUSTOM').length > 0) {
        this.setState({
          'alreadyUploaded' : true,
        });
      }
    }
  }

  handleSetInitialData = (listOfData, dayType) => {    
    const initialAllowance = [];
    const initialChargeCustomer = [];
    const initialParkingDayConfigId = [];

    for (let i = 0; i < listOfData.length; i++) {      
      initialAllowance.push(listOfData[i].parkingDayConfigAllowance ? commonConstant.parkingDayConfigMemberType.filter((item) => item.value === listOfData[i].parkingDayConfigAllowance)[0] : null);
      initialChargeCustomer.push(listOfData[i].parkingDayConfigChargeCustomer ? commonConstant.parkingDayConfigChargeCustomerType.filter((item) => item.value === listOfData[i].parkingDayConfigChargeCustomer)[0] : null);

      if (this.props.pathMatch && this.props.pathMatch.path === commonConstant.pathParkingDayConfig) {
        initialParkingDayConfigId.push(listOfData[i].parkingDayConfigID);
      }
      
      this[`${dayType}Allowance`].push(createRef());
      this[`${dayType}ChargeCustomer`].push(createRef());
    }

    this.setState({      
      [`${dayType}Allowance`]: initialAllowance,
      [`${dayType}ChargeCustomer`]: initialChargeCustomer,
      [`${dayType}ParkingDayConfigId`]: initialParkingDayConfigId,
    });
  }

  handleCheckIsCanSave = () => {
    const { weekdayAllowance, weekdayChargeCustomer, weekendAllowance, weekendChargeCustomer } = this.state;
    const isCanSave = [];

    isCanSave.push(!weekdayAllowance.includes(null));
    isCanSave.push(!weekdayChargeCustomer.includes(null));
    isCanSave.push(!weekendAllowance.includes(null));
    isCanSave.push(!weekendChargeCustomer.includes(null));    

    return !isCanSave.includes(false);
  }

  handleData = (dayType) => {
    const data = [];

    for (let index = 0; index < this.state[`${dayType}Allowance`].length; index++) {
      const zoneNumber = index + 1 < 9 ? `0${index + 1}` : `${index + 1}`;
      if (this.props.pathMatch && this.props.pathMatch.path === commonConstant.pathParkingDayConfig) {
        data.push(
          {
            'parkingDayConfigDayType': `${dayType.toUpperCase()}`,          
            'parkingDayConfigParkingZone': `IN-${zoneNumber}/OUT-${zoneNumber}`,
            'parkingDayConfigAllowance': this.state[`${dayType}Allowance`][index] ? this.state[`${dayType}Allowance`][index].value : null,
            'parkingDayConfigChargeCustomer': this.state[`${dayType}ChargeCustomer`][index] ? this.state[`${dayType}ChargeCustomer`][index].value : null,
            'parkingDayConfigStartDatetime' : null,
            'parkingDayConfigEndDatetime' : null,
            'parkingDayConfigID' : this.state[`${dayType}ParkingDayConfigId`][index] ,
          },
        );
      } else {
        data.push(
          {
            'parkingDayConfigDayType': `${dayType.toUpperCase()}`,          
            'parkingDayConfigParkingZone': `IN-${zoneNumber}/OUT-${zoneNumber}`,
            'parkingDayConfigAllowance': this.state[`${dayType}Allowance`][index] ? this.state[`${dayType}Allowance`][index].value : null,
            'parkingDayConfigChargeCustomer': this.state[`${dayType}ChargeCustomer`][index] ? this.state[`${dayType}ChargeCustomer`][index].value : null,
            'parkingDayConfigStartDatetime' : null,
            'parkingDayConfigEndDatetime' : null,
          },
        );
      }
    }

    return data;
  }

  handleCustomData = () => {
    const customData = [];
    const { customDayConfigData } = this.state;
    if (customDayConfigData.length > 0) {
      let startDateTime;
      let endDateTime;
      for (let customIndex = 0; customIndex < customDayConfigData.length; customIndex++) {
        if (customDayConfigData[customIndex].TIME_TYPE != '' && customDayConfigData[customIndex].TIME_TYPE === 'CUSTOM') {
          startDateTime = customDayConfigData[customIndex].DATE != '' && customDayConfigData[customIndex].START_TIME != '' ? `${customDayConfigData[customIndex].DATE}T${customDayConfigData[customIndex].START_TIME}:00Z` : null;
          endDateTime = customDayConfigData[customIndex].DATE != '' && customDayConfigData[customIndex].END_TIME != '' ? `${customDayConfigData[customIndex].DATE}T${customDayConfigData[customIndex].END_TIME}:00Z` : null;
        } else if (customDayConfigData[customIndex].TIME_TYPE != '' && customDayConfigData[customIndex].TIME_TYPE === 'ALL_DAY') {
          startDateTime = customDayConfigData[customIndex].DATE != '' ? `${customDayConfigData[customIndex].DATE}T00:00:00Z` : null;
          endDateTime = customDayConfigData[customIndex].DATE != '' ? `${customDayConfigData[customIndex].DATE}T23:59:00Z` : null;
        }

        const newStartDate = startDateTime ? new Date(startDateTime) : null;
        const newEndDate = endDateTime ? new Date(endDateTime) : null;        

        if (newStartDate && endDateTime) {
          newStartDate.setHours(newStartDate.getHours() - 7);
          newEndDate.setHours(newEndDate.getHours() - 7);   
        }      
        
        customData.push(
          {
            'parkingDayConfigDayType': 'CUSTOM',          
            'parkingDayConfigParkingZone': customDayConfigData[customIndex].PARKING_ZONE != '' ? `IN-${customDayConfigData[customIndex].PARKING_ZONE < 9 ? `0${customDayConfigData[customIndex].PARKING_ZONE}` : `${customDayConfigData[customIndex].PARKING_ZONE}`}/OUT-${customDayConfigData[customIndex].PARKING_ZONE < 9 ? `0${customDayConfigData[customIndex].PARKING_ZONE}` : `${customDayConfigData[customIndex].PARKING_ZONE}`}` : '',
            'parkingDayConfigAllowance': customDayConfigData[customIndex].ALLOWANCE != '' ? customDayConfigData[customIndex].ALLOWANCE : '',
            'parkingDayConfigChargeCustomer': customDayConfigData[customIndex].CHARGE_CUSTOMER != '' ? customDayConfigData[customIndex].CHARGE_CUSTOMER : '',
            'parkingDayConfigStartDatetime' : newStartDate ? `${dateUTCYYYYMMDD(newStartDate)}T${timeUTCFormatHHMM(newStartDate)}:00Z` : null,
            'parkingDayConfigEndDatetime' : newEndDate ? `${dateUTCYYYYMMDD(newEndDate)}T${timeUTCFormatHHMM(newEndDate)}:00Z` : null,
          },
        );
      }

      this.setState({
        'alreadyUploaded' : true,
      });
    }

    return customData;
  }

  handleDispatchData = () => {
    if (this.props.pathMatch && this.props.pathMatch.path === commonConstant.pathParkingDayConfig) {
      this.props.dispatch(setBuildingParkingDayConfig({
        'parkingDayConfig' : [
          ...this.handleData('weekday'),
          ...this.handleData('weekend'),          
        ],
        'isCanSave' : this.handleCheckIsCanSave(),
      }));
    } else {
      this.props.dispatch(setBuildingParkingDayConfig({
        'parkingDayConfig' : [
          ...this.handleData('weekday'),
          ...this.handleData('weekend'),
          ...this.handleCustomData(),
        ],
        'isCanSave' : this.handleCheckIsCanSave(),
      }));
    }
  }

  handleEventWithIndex = (key, event, index, dayType) => {
    const item = [...this.state[key]];
    item[index] = event;
    this.setState({ [key]: item }, () => {this.handleDispatchData();});

    if (key === `${dayType}Allowance`) {
      this[`${dayType}Allowance`][index].current.handleShowItem();
    } else if (key === `${dayType}ChargeCustomer`) {
      this[`${dayType}ChargeCustomer`][index].current.handleShowItem();
    }      
  }

  handleGenerateParkingDayConfig = (dayType) => {
    const parkingdayConfigContent = [];

    for (let index = 0; index < this.state[`${dayType}Allowance`].length; index++) {
      const zoneNumber = index + 1 < 9 ? `0${index + 1}` : `${index + 1}`;
      parkingdayConfigContent.push(
        <div key={index} className="zone-container">
          <HeaderSection title={`${dayType.charAt(0).toUpperCase() + dayType.slice(1)} - Zone ${zoneNumber}`} />
          <div className="zone-attribute">
            <div className="time-type-container">
              <div className="time-type-label">Time type</div>
              <div className="time-type-value">all day</div>
            </div>    
            <div className="allowance-container">
              <div className="allowance-label">Allowance</div>
              <div className="allowance-dropdown">
                <Dropdown 
                  template="b" 
                  placeholder="Choose allowance"
                  value={this.state[`${dayType}Allowance`][index] != null ? this.state[`${dayType}Allowance`][index].label : null} 
                  ref={this[`${dayType}Allowance`][index]} >
                  {
                    commonConstant.parkingDayConfigMemberType.map((ele, parkingDayConfigMemberTypeIndex) => (
                      <div
                        key={parkingDayConfigMemberTypeIndex}
                        className={`item${this.state[`${dayType}Allowance`] && this.state[`${dayType}Allowance`].value === ele.value ? ' active' : ''}`}
                        onClick={() => this.handleEventWithIndex(`${dayType}Allowance`, ele, index, dayType)}
                      >{ele.label}</div>
                    ))
                  }
                </Dropdown>
              </div>
            </div>
            <div className="charge-customer-container">
              <div className="charge-customer-label">Charge customer</div>
              <div className="charge-customer-dropdown">
                <Dropdown 
                  template="b" 
                  placeholder="Choose Charge customer"
                  value={this.state[`${dayType}ChargeCustomer`][index] != null ? this.state[`${dayType}ChargeCustomer`][index].label : null} 
                  ref={this[`${dayType}ChargeCustomer`][index]} >
                  {
                    commonConstant.parkingDayConfigChargeCustomerType.map((ele, parkingDayConfigMemberTypeIndex) => (
                      <div
                        key={parkingDayConfigMemberTypeIndex}
                        className={`item${this.state[`${dayType}ChargeCustomer`] && this.state[`${dayType}ChargeCustomer`].value === ele.value ? ' active' : ''}`}
                        onClick={() => this.handleEventWithIndex(`${dayType}ChargeCustomer`, ele, index, dayType)}
                      >{ele.label}</div>
                    ))
                  }
                </Dropdown>
              </div>
            </div>               
          </div>            
        </div>,

      );
    }

    return parkingdayConfigContent;
  }

  handleCallback = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { 'type':'binary' });
        const customParkingDayConfigWsName = wb.SheetNames[0];
        const customParkingDayConfigWs = wb.Sheets[customParkingDayConfigWsName];
        const customParkingDayConfigData = XLSX.utils.sheet_to_json(customParkingDayConfigWs);      
          
        this.setState({
          'file' : file,
          'customDayConfigData' : customParkingDayConfigData,                    
        }, () => {this.handleDispatchData();});
      };    
      reader.readAsBinaryString(file);
    } catch (error){
      this.setState({
        'error' : true,
        'alreadyUploaded' : false,
      });
    }
  }

  handleCustomSection = () => {
    const { error, alreadyUploaded } = this.state;

    return <>
      <HeaderSection title="Custom" isHeader={true} />
      <Card>
        <div className="custom-container">
          <div className="custom-day-config-container">
            <div className="custom-day-config-label">Custom day config</div>
            <div className="custom-day-config-upload">
              <InputWithUpload
                id="tenant-componentDidMount"
                template="a"
                placeholder="Choose file to upload"
                callback={this.handleCallback}
                accept=".xlsx, .xls"                
              />
              <div className="error-text">{error ? 'Upload Error: The file could not be processed. Please ensure the file meets the required format and re-upload.' : ''}</div>
              <div className="already-uploaded-text">{alreadyUploaded ? 'File already uploaded. If you need to update the file, please re-upload the latest version.' : ''}</div>
            </div>                
          </div>
          <div className="custom-day-config-template-file-container">
            <div className="custom-day-config-template-file-label">Custom day config template file</div>
            <div className="custom-day-config-template-file-download">
              <div className="custom-day-config-file-download-label">custom_parking_day_config_template_file.xlsx</div>
              <div>
                <Button onClick={() => window.open(commonConstant.envCustomParkingDayConfigTemplate)} className="btn-download btn-secondary" >Download</Button>
              </div>
            </div>                
          </div>
        </div>
      </Card>
    </>;
  }

  render() {    
    return (
      <div className="BuildingParkingDayConfig">
        <HeaderSection title="Weekday" isHeader={true} />
        <Card>
          {this.handleGenerateParkingDayConfig('weekday')}
        </Card>
        <HeaderSection title="Weekend" isHeader={true} />
        <Card>
          {this.handleGenerateParkingDayConfig('weekend')}
        </Card>
        {
          this.props.pathMatch && this.props.pathMatch.path === commonConstant.pathParkingDayConfig ? null : this.handleCustomSection()
        }
      </div>
    );
  }
}

const mapStateToProps = ({ buildingParkingDayConfig }) => ({
  'buildingParkingDayConfig': buildingParkingDayConfig.data,
});

export default connect(mapStateToProps)(BuildingParkingDayConfig);

BuildingParkingDayConfig.propTypes = {
  'dispatch' : PropTypes.func,
  'pathMatch' : PropTypes.shape({
    'path' : PropTypes.string,
  }),
  'buildingParkingDayConfig' : PropTypes.shape({
    'parkingDayConfig' :PropTypes.arrayOf(
      PropTypes.shape({          
        'parkingDayConfigDayType': PropTypes.string,        
        'parkingDayConfigParkingZone': PropTypes.string,
        'parkingDayConfigAllowance': PropTypes.string,
        'parkingDayConfigChargeCustomer': PropTypes.string,
        'parkingDayConfigStartDatetime': PropTypes.string,
        'parkingDayConfigEndDatetime': PropTypes.string,
      }),
    ),
  }),
};
